import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


export const orderApi = createApi({
    reducerPath: "orderApi",
    baseQuery: fetchBaseQuery({ baseUrl: "/api/v1" }),
    tagTypes: ["Order", "AdminOrders"],
    endpoints: (builder) => ({

        createNewOrder: builder.mutation({
            query(body) {
                return {
                    url: "/orders/new",
                    method: "POST",
                    body,

                    // ===
                    //  credentials: "omit",
                };
            },
        }),
        MyOrders: builder.query({
            query: () => `/me/orders`
        }),
        OrderDetails: builder.query({
            query: (id) => `/orders/${id}`,
            providesTags: ["Order"]
        }),
        getDashboardSales: builder.query({
            query: ({ startDate, endDate }) => `/admin/get_sales/?startDate=${startDate}&endDate=${endDate}`
        }),
        getAdminOrders: builder.query({
            query: () => `/admin/orders`,
            providesTags: ["AdminOrders"]
        }),
        updateOrder: builder.mutation({
            query({ id, body }) {
                return {
                    url: `/admin/orders/${id}`,
                    method: "PUT",
                    body,
                };
            },
            invalidatesTags: ["Order"]
        }),
        updateOrderPayment: builder.mutation({
            query({ id, status }) {
                return {
                    url: `/admin/orders/${id}/payment`,
                    method: "PUT",
                    body: { status },
                };
            },
            invalidatesTags: ["Order"]
        }),
        deleteOrder: builder.mutation({
            query(id) {
                return {
                    url: `/admin/orders/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: ["AdminOrders"]
        }),
    }),

});

export const {
    useCreateNewOrderMutation,
    useMyOrdersQuery,
    useOrderDetailsQuery,
    useLazyGetDashboardSalesQuery,
    useGetAdminOrdersQuery,
    useUpdateOrderMutation,
    useUpdateOrderPaymentMutation,
    useDeleteOrderMutation,
} = orderApi;
